import { useState } from 'react';
import { Button } from '@mui/material';
import { UploadFileDialog } from './UploadFileDialog';
import Iconify from 'src/components/iconify/index.tsx';
import { useAppSearchParams } from 'src/hooks/useAppSearchParams';
import { useUploadParticipantsMutation } from 'src/api/pickems/uploadPrivateUsers';

export const UploadParticipantsButton = () => {
  const { pickemId } = useAppSearchParams();

  const [openUploadParticipantsDialog, setOpenUploadParticipantsDialog] =
    useState(false);

  const { mutateAsync: uploadParticipants } = useUploadParticipantsMutation({
    pickemId,
  });

  const closeUploadParticipantsDialog = () => {
    setOpenUploadParticipantsDialog(false);
  };

  const fileUpload = (file: File) => {
    const bodyFormData = new FormData();
    bodyFormData.append('file', file);

    uploadParticipants({ bodyFormData }).then(() => {
      closeUploadParticipantsDialog();
    });
  };

  return (
    <>
      <Button
        variant='contained'
        startIcon={<Iconify icon='eva:plus-fill' />}
        onClick={() => setOpenUploadParticipantsDialog(true)}
        sx={{ mr: 1 }}
      >
        Upload Participants
      </Button>

      <UploadFileDialog
        open={openUploadParticipantsDialog}
        onSuccessHandler={(file: File) => fileUpload(file)}
        onClose={closeUploadParticipantsDialog}
      />
    </>
  );
};
